import React, {useEffect, useState} from "react";
import {Button, Col, Input, Row, Tooltip, InputProps} from "antd";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
//TODO : Add localization strings
export const HideableInput = ({
    value,
    defaultHidden = false,
    onChange,
    specialChar = "*",
    ...props
}: InputProps) => {
    const [isHidden, setIsHidden] = useState(defaultHidden);
    const toggleHidden = () => setIsHidden(!isHidden);
    const [inputValue, setInputValue] = useState(value);
    const [maskedValue, setMaskedValue] = useState(value.replace(/./g, specialChar));
    useEffect(() => {
        setInputValue(value);
        setMaskedValue(value.replace(/./g, specialChar));
    }, []);

    const handleChange = e => {
        const str = e.target.value;
        setInputValue(str);
        setMaskedValue(str.replace(/./g, specialChar));
        onChange(str);
    };
    return (
        <Row>
            <Col flex="1">
                <Input
                    disabled={isHidden}
                    value={isHidden ? maskedValue : inputValue}
                    onChange={handleChange}
                    {...props}
                />
            </Col>
            <Col>
                <Tooltip title={isHidden ? "Göster" : "Gizle"}>
                    {isHidden ? (
                        <Button icon={<EyeInvisibleOutlined />} onClick={toggleHidden} />
                    ) : (
                        <Button icon={<EyeTwoTone />} onClick={toggleHidden} />
                    )}
                </Tooltip>
            </Col>
        </Row>
    );
};
